import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const getSubsiteCategories = async () => {
    console.log("BEFORE SUBSITE CATEGORIES RESPONSE");
  	const response = await axios
    	.get(process.env.REACT_APP_API_URL + "/categories", { headers: AuthHeader.authHeader() });
    console.log("SUBSITE CATEGORIES RESPONSE", response);
    return response.data;
};

const updateCategoryForProduct = async (categoryId, value, productId) => {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/categories", 
        { categoryId: categoryId,
            value: value,
            productId: productId }, 
        { headers: AuthHeader.authHeader()});
    return response.data;
};

const updateCategoryOrder = async (categories) => {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/categories/order", 
    { "categories" : categories}, 
    { headers: AuthHeader.authHeader()});
    return response.data;
};

const getAllCategories = () => {
    return axios
      .get(process.env.REACT_APP_API_URL + "/admin/allcategories", { headers: AuthHeader.authHeader() })
      .then((response) => {
          if (response.data) {
              localStorage.setItem("menu", JSON.stringify(response.data));
          }
          return response.data;
      });
};

const updateCategoryName = async (category) => {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/category", 
        { id: category.id,
            categoryName: category.categoryName }, 
        { headers: AuthHeader.authHeader()});
    return response.data;
}

const generateMenu = async () => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/generateMenu" , { headers: AuthHeader.authHeader() });
    return response.data;
}

const getIgniteCategories = async () => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/ignitecategories", { headers: AuthHeader.authHeader() });
    return response.data;
}

const updateIgniteCategoryForStyle = async (categoryId, value, styleId) => {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/ignitecategories", 
        { categoryId: categoryId,
            value: value,
            styleId: styleId }, 
        { headers: AuthHeader.authHeader()});
    return response.data;
}

const CategoryService = {
    getSubsiteCategories,
    updateCategoryOrder,
    getAllCategories,
    updateCategoryForProduct,
    updateCategoryName,
    generateMenu,
    
    getIgniteCategories,
    updateIgniteCategoryForStyle,
};
export default CategoryService;